import {
  OrderLineStatus, OrderLine, Product, Package, Warehouse, TreatmentCategory,
} from './models/models';
import OrderService from '../services/order.service';
import Errors from '../utils/errors';

export default {
  namespaced: true,
  state: {
    isModalOpen: null,
    orderLineType: null,
    orderLineId: null,
    isNewOrderLine: null,
    lineIndex: null,
    orderErrors: new Errors(),
  },
  mutations: {
    isModalOpen(state, isOpen) {
      state.isModalOpen = isOpen;
    },
    orderLineId(state, orderLineId) {
      state.orderLineId = orderLineId;
    },
    orderLineType(state, orderLineType) {
      state.orderLineType = orderLineType;
    },
    lineIndex(state, lineIndex) {
      state.lineIndex = lineIndex;
    },
    isNewOrderLine(state, isNewOrderLine) {
      state.isNewOrderLine = isNewOrderLine;
    },
    orderErrors(state, orderErrors) {
      state.orderErrors.set(orderErrors);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getOrderLineStatuses');
    },
    newOrderLine({ dispatch, rootState }, props) {
      return OrderLine.new()
        .then((line) => {
          line.$update({
            quantity: props.hasOwnProperty('quantity') ? props.quantity : null,
            order_id: rootState.orders.orderId,
            product_id: props.product_id ? props.product_id : null,
          })
            .then(() => {
              dispatch('openOrderLineModal', {
                id: line.id,
                line_type: props.line_type,
                isNewOrderLine: true,
              });
            });
        });
    },
    getOrderLineStatuses() {
      OrderService.getOrderLineStatuses()
        .then((statuses) => OrderLineStatus.create({ data: statuses }));
    },
    openOrderLineModal({ commit }, props) {
      commit('isNewOrderLine', props.isNewOrderLine);
      commit('orderLineId', props.id);
      commit('isModalOpen', true);
      commit('orderLineType', props.line_type);
      commit('lineIndex', props.lineIndex);
    },
    updateOrderLineProps({ state }, props) {
      if (props.hasOwnProperty('product')) {
        Product.insert({ data: props.product });
      }

      if (props.hasOwnProperty('dispatching_warehouse')) {
        Warehouse.insert({ data: props.dispatching_warehouse });
      }

      if (props.hasOwnProperty('receiving_warehouse')) {
        Warehouse.insert({ data: props.receiving_warehouse });
      }

      if (props.hasOwnProperty('package')) {
        Package.insert({ data: props.package });
      }

      if (props.hasOwnProperty('job_treatment_category')) {
        TreatmentCategory.insert({ data: props.job_treatment_category });
      }

      OrderLine.update({
        where: state.orderLineId,
        data: props,
      });
    },
    clearCurrentOrderLine({ state, dispatch }) {
      if (state.isNewOrderLine === true) {
        dispatch('deleteOrderLine');
      }
    },
    deleteOrderLine({ state }) {
      OrderLine.delete(state.orderLineId);
    },
  },
  getters: {
    orderLineStatuses() {
      return OrderLineStatus.all();
    },
    orderLine(state) {
      return OrderLine.query()
        .withAllRecursive()
        .where('id', state.orderLineId)
        .first();
    },
  },
};
